import { render, staticRenderFns } from "./DailyResidentialDispensationPlan.vue?vue&type=template&id=ac22c114&scoped=true&"
import script from "./DailyResidentialDispensationPlan.vue?vue&type=script&lang=js&"
export * from "./DailyResidentialDispensationPlan.vue?vue&type=script&lang=js&"
import style0 from "./DailyResidentialDispensationPlan.vue?vue&type=style&index=0&id=ac22c114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22c114",
  null
  
)

export default component.exports